export const CARE_ORDER_HISTORY_QUERY = {
    QUERY_RANGE_DAYS: 15,
};
export const DEFAULT_EXPECTED_START_TIME_HOUR = 10;
export const DEFAULT_EXPECTED_START_TIME_MINUTE = 0;
export const TIME_MANIPULATION = {
    HOUR: { TYPE: 'hour', UNIT: 1 },
    MINUTE: { TYPE: 'minute', UNIT: 30 },
};
